@let passenger = data.passenger;

<div class="d-flex flex-column g-4">
  <div class="d-flex flex-column g-1 traveler-info-row-item">
    <h3 class="bold">{{ data.passenger.fullName }}</h3>
    <ng-content />
  </div>

  <ds-border-wrapper>
    <div class="w-100 d-flex flex-column g-4">
      <div class="w-100 d-flex flex-wrap traveler-info-row">
        @for (field of fields; track field) {
          <ng-container *ngTemplateOutlet="travelerSwitch; context: { type: field }" />
        }
      </div>

      @if (false) {
        <!--        Add after backend changes-->
        <div class="w-100 traveler-info-separator"></div>

        <div
          (click)="isCollapsed = !isCollapsed"
          class="d-flex cursor-pointer align-items-center g-2"
        >
          <div
            class="arrow d-flex align-items-center justify-content-center"
            [class.expanded]="!isCollapsed"
          >
            <img src="assets/icons/keyboard_arrow_down_blue.svg" alt="arrow-up" />
          </div>
          <p class="bold">Frequent flyer, TSA PreCheck, redress and more</p>
        </div>

        @if (!isCollapsed) {
          <div @toggle class="w-100 d-flex flex-wrap traveler-info-row">
            @for (field of additionalFields; track field) {
              <ng-container *ngTemplateOutlet="travelerSwitch; context: { type: field }" />
            }

            <div class="d-flex flex-column g-1 traveler-info-row-item">
              <p class="caption semi-bold">Frequent flyer details</p>
              <div class="d-flex flex-wrap align-items-center frequent-flyer-details">
                <div class="d-flex align-items-center g-2">
                  @if (false) {
                    <!--        Add image after backend changes-->
                    <!--                    <img  alt="logo"/>-->
                  }
                  <p>Executive Club</p>
                </div>

                <div class="dot-wrapper">
                  <ds-dot-separator />
                </div>
                <p data-id="executive-club">BA1234567</p>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </ds-border-wrapper>
</div>

<ng-template
  #travelerItem
  let-title="title"
  let-subtitle="subtitle"
  let-dataId="dataId"
  let-img="img"
>
  <div class="d-flex flex-column g-1 traveler-info-row-item">
    <p class="caption semi-bold">{{ title }}</p>
    <div class="d-flex align-items-center g-2">
      @if (img) {
        <div class="traveler-info-row-item-img"></div>
        <!--        Add image after backend changes-->
      }
      <p [attr.data-id]="dataId">{{ subtitle }}</p>
    </div>
  </div>
</ng-template>

<ng-template #travelerSwitch let-type="type">
  @switch (type) {
    @case (travelerInfoBlocks.FirstName) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.FirstName,
            subtitle: passenger.firstName,
            dataId: 'first-name',
          }
        "
      />
    }
    @case (travelerInfoBlocks.MiddleName) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.MiddleName,
            subtitle: passenger.middleName ?? '–',
            dataId: 'middle-name',
          }
        "
      />
    }
    @case (travelerInfoBlocks.LastName) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.LastName,
            subtitle: passenger.lastName,
            dataId: 'last-name',
          }
        "
      />
    }
    @case (travelerInfoBlocks.Gender) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.Gender,
            subtitle: passenger.gender | titlecase,
            dataId: 'gender',
          }
        "
      />
    }
    @case (travelerInfoBlocks.DateOfBirth) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.DateOfBirth,
            subtitle: passenger.birthday | date: 'MMMM d, y',
            dataId: 'date-of-birth',
          }
        "
      />
    }
    @case (travelerInfoBlocks.Citizenship) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.Citizenship,
            subtitle: passenger.passport?.country?.name ?? '-',
            dataId: 'citizenship',
          }
        "
      />
    }
    @case (travelerInfoBlocks.ExpiryDate) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.ExpiryDate,
            subtitle: passenger.passport?.expiration | date: 'MMMM d, y',
            dataId: 'expiry-date',
          }
        "
      />
    }
    @case (travelerInfoBlocks.PassportNumber) {
      <!-- Future implementation for passport number -->
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.PassportNumber,
            subtitle: passenger.passport ?? '-',
            dataId: 'passport-number',
          }
        "
      />
    }
    @case (travelerInfoBlocks.Email) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.Email,
            subtitle: 'JessicaA@gmail.com',
            dataId: 'email',
          }
        "
      />
    }
    @case (travelerInfoBlocks.KnownTravelerNumber) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.KnownTravelerNumber,
            subtitle: '123456789',
            dataId: 'known-traveler-number',
          }
        "
      />
    }
    @case (travelerInfoBlocks.RedressNumber) {
      <ng-container
        *ngTemplateOutlet="
          travelerItem;
          context: {
            title: travelerInfoBlocks.RedressNumber,
            subtitle: '87654321',
            dataId: 'redress-number',
          }
        "
      />
    }
  }
</ng-template>
